import { render } from "./PermissionGroupIndex.vue?vue&type=template&id=18c354a2"
import script from "./PermissionGroupIndex.vue?vue&type=script&lang=js"
export * from "./PermissionGroupIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__